import PlayIcon from "@redotech/redo-icons/play-circle_filled.svg";
import type { RuleActionsStep } from "@redotech/redo-model/advanced-flow/rules/schemas";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../../steps";
import { BaseNode } from "../base-node";

export interface RuleActionsNodeData {
  step: PartialWithRequiredType<RuleActionsStep>;
  deleteElements: (id: string) => void;
  hovered?: boolean;
}

export const RuleActionsNode = memo(function RuleActionsNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: RuleActionsNodeData;
  selected?: boolean;
}) {
  const actionsCount = data.step.actions?.length ?? 0;
  const summary =
    actionsCount === 0
      ? "No actions"
      : `${actionsCount} action${actionsCount > 1 ? "s" : ""}`;

  return (
    <>
      <Handle position={Position.Top} type="target" />
      <BaseNode
        hovered={data.hovered}
        icon={
          <RedoFeaturedIcon
            color="success"
            Icon={PlayIcon}
            shape="circle"
            size="md"
          />
        }
        onDelete={() => data.deleteElements(id)}
        selected={selected}
        step={data.step}
        title="Rule actions"
      >
        <Flex dir="column" gap="xs" w="full">
          <Text
            fontSize="xs"
            style={{ color: "var(--redo-colors-text-tertiary)" }}
          >
            {summary}
          </Text>
        </Flex>
      </BaseNode>
      <Handle position={Position.Bottom} type="source" />
    </>
  );
});
